/**
 * Open Status html ajax
 * ======================================
 * - handled with ajax/index.php
 */

 const ELEMENT = '#contact-box-core-ajax'

 class OpenStatus {
   constructor() {
     this.element = document.querySelector(ELEMENT)
     this.ajaxUrl = '/app/themes/ipress/ajax/index.php'

     this.ajaxHandler()
   }

   ajaxHandler = () => {
    if(!this.element){
      return
    }

     this.element.classList.add('is-loading')

     const xhr = new XMLHttpRequest()
     xhr.open('POST', this.ajaxUrl, true)
     xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
     xhr.send('action=openStatus')

     xhr.onreadystatechange = () => {
       if (xhr.readyState === 4) {
         // ok
         if (xhr.status === 200) {
           const response = JSON.parse(xhr.response)

           this.element.innerHTML = response.html

           this.element.classList.remove('is-loading')
           this.element.classList.add('is-loaded')
         }
         // error
         else {
           console.log('ajaxForm error!', xhr)
         }
       }
     }
   }
 }

 new OpenStatus()
